import './index.css'
import { createRoot } from 'react-dom/client'
import React from 'react'
import { ToastProvider } from '@/components/ui/ToastProvider'
import { useToasts } from '@/components/ui/toast-context'
import AppRoot from './App'
import { createRoot as createRootClient } from 'react-dom/client'

// Ensure motion is allowed even if OS has reduced motion preference
try {
 document.documentElement.setAttribute('data-allow-motion', 'true')
} catch {
 // Ignore errors when setting motion attribute
}

// Global 401 handler: redirect to login and show toast
{
 const anyWindow = window as unknown as {
   __auth401HandlerRegistered?: boolean
 };
 if (!anyWindow.__auth401HandlerRegistered) {
   window.addEventListener('app:auth-401', () => {
     try {
       const event = new CustomEvent('toast:push', { detail: { message: 'Session expired. Please log in again.', type: 'error' } })
       window.dispatchEvent(event)
     } catch {
       // Ignore toast dispatch errors
     }
     try {
       window.location.assign('/login')
     } catch {
       // Ignore navigation errors
     }
   })
   anyWindow.__auth401HandlerRegistered = true
 }
}

// Lightweight bridge to trigger toasts globally without importing hooks everywhere
{
  const anyWindow = window as unknown as {
    __toastPushHandlerRegistered?: boolean
  };
  if (!anyWindow.__toastPushHandlerRegistered) {
    window.addEventListener('toast:push', (e: Event) => {
      try {
        const detail = (e as CustomEvent).detail as { message: string; type?: 'success' | 'error' | 'warning' | 'info'; duration?: number }

        const notify = () => {
         const container = document.createElement('div')
         document.body.appendChild(container)
         const tempRoot = createRootClient(container)
          function Temporary() {
            const { push } = useToasts()
            React.useEffect(() => {
              push(detail.message, detail.type, detail.duration)
              // Keep the root alive for the toast duration
              setTimeout(() => {
                try { tempRoot.unmount(); document.body.removeChild(container) } catch {
                  // Ignore cleanup errors
                }
              }, (detail.duration || 3000) + 1000)
            }, [push])
            return null
          }
          tempRoot.render(
            <ToastProvider>
              <Temporary />
            </ToastProvider>
          )
        }
        notify()
      } catch {
        // Ignore toast notification errors
      }
    })
    anyWindow.__toastPushHandlerRegistered = true
  }
}
createRoot(document.getElementById('root')!).render(<AppRoot />)

